export const Circle90By90Theme = {
    width: '90px',
    height: '90px',
};

export const Line150By20Theme = {
    width: '150px',
    height: '20px',
};

export const Line260By20Theme = {
    width: '260px',
    height: '20px',
};

export const Line150By150Theme = {
    width: '200px',
    height: '150px',
};

export const Line400By200Theme = {
    width: '300px',
    height: '250px',
};

export const Line100By500Theme = {
    width: '100%',
    height: '500px',
};

export const Line100By300Theme = {
    width: '100%',
    height: '300px',
};

export const Line100By200Theme = {
    width: '100%',
    height: '200px',
};

export const Line300By100Theme = {
    height: '100px',
};

export const Line100By90Theme = {
    height: '90px',
};

export const Line100By60Theme = {
    height: '60px',
};

export const Line100By40Theme = {
    height: '40px',
};

export const Line100By50Theme = {
    height: '50px',
};

export const Line100PercentBy400Theme = {
    height: '400px',
};

export const Line100PercentBy700Theme = {
    height: '700px',
};

export const Line110By40ThemeWithBR = {
    width: '110px',
    'border-radius': '22px',
    height: '40px',
};

export const CardWithBR = {
    'border-radius': '8px',
    height: '80px',
    margin: '4px',
};

export const longHeightCardWithBR = {
    'border-radius': '8px',
    height: '320px',
    margin: '4px',
};
